import { Box, Link, Typography } from '@mui/material';
import { CuriosityValue, CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import type { CuriosityTranslation } from '@procureai/curiosity-ui-mui';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { Link as RouterLink } from 'react-router-dom';

import { SupplierEntity } from '../SupplierAutocomplete';
import { ReferenceTag } from '~/components/ReferenceTag/ReferenceTag';
import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';
import { RouteId } from '~/routes';

export interface SupplierHeadingProps {
  supplierId: string;
}

export const SupplierHeading = ({ supplierId }: SupplierHeadingProps) => (
  <CuriosityValue ns={CuriosityNamespaceType.SUPPLIER} i18nKey={supplierId} valueGetter={(ct) => ct}>
    {(value) => {
      const ct = value as CuriosityTranslation<SupplierEntity>;
      const supplierName = ct.value;
      const externalReference = ct.entity.sourceReference;

      const referenceTag = externalReference && (
        <ReferenceTag variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
          {externalReference}
        </ReferenceTag>
      );

      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            minHeight: '2.5em',
          }}
        >
          <TooltipTypography title={supplierName}>
            <Restricted
              needs={{ permission: Permission.BaseSupplierList }}
              fallback={
                <Typography variant="body1" component="div" noWrap>
                  {supplierName}
                  {referenceTag}
                </Typography>
              }
            >
              <Link
                underline="hover"
                color="text.primary"
                variant="body1"
                component={RouterLink}
                to={RouteId.supplierDetail(supplierId)}
              >
                {supplierName}
              </Link>
              {referenceTag}
            </Restricted>
          </TooltipTypography>
        </Box>
      );
    }}
  </CuriosityValue>
);
